(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-home-header-v1"] && !Shopify.designMode) return;
  try {
    
(() => {
    const setup = (root) => {
        root.querySelectorAll('.homeHeadV1Video').forEach((video) => {
            if (video.dataset.initialized) return;
            video.dataset.initialized = 'true';
            const button = video.parentElement.querySelector('.homeHeadV1VideoToggle');
            const motion = matchMedia('(prefers-reduced-motion: reduce)');
            let userPaused = false;
            let visible = false;
            let pending = false;
            let blocked = false;
            const allowed = () => visible && !motion.matches && !document.hidden && !userPaused;
            const syncButton = () => {
                button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
                button.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
            };
            const start = () => {
                video.autoplay = allowed();
                if (!allowed()) { video.pause(); return; }
                if (pending || blocked || !video.paused) return;
                video.defaultMuted = true;
                video.muted = true;
                video.playsInline = true;
                if (!video.getAttribute('src')) video.src = video.dataset.src;
                const fallback = video.dataset.fallbackSrc;
                if (video.error && fallback && video.getAttribute('src') !== fallback) video.src = fallback;
                pending = true;
                video.play().then(() => {
                    if (!allowed()) video.pause();
                }).catch((error) => {
                    blocked = error.name === 'NotAllowedError';
                    button.hidden = motion.matches;
                    syncButton();
                }).finally(() => {
                    pending = false;
                    if (video.error && fallback && video.getAttribute('src') !== fallback) start();
                });
            };
            const reveal = () => {
                if (!allowed() || video.paused) return;
                video.classList.add('is-ready');
                button.hidden = false;
                syncButton();
            };
            video.addEventListener('playing', () => {
                if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(reveal);
                else requestAnimationFrame(reveal);
            });
            video.addEventListener('pause', syncButton);
            video.addEventListener('loadeddata', start);
            video.addEventListener('canplay', start);
            video.addEventListener('error', () => {
                video.classList.remove('is-ready');
                button.hidden = true;
                if (video.dataset.fallbackSrc && video.getAttribute('src') !== video.dataset.fallbackSrc) start();
            });
            button.addEventListener('click', () => {
                userPaused = !video.paused;
                blocked = false;
                start();
            });
            motion.addEventListener('change', () => {
                if (motion.matches) {
                    video.autoplay = false;
                    video.pause();
                    video.classList.remove('is-ready');
                    button.hidden = true;
                } else { blocked = false; start(); }
            });
            const resume = () => {
                if (!video.isConnected) return;
                blocked = false;
                start();
            };
            document.addEventListener('visibilitychange', resume);
            window.addEventListener('pageshow', resume);
            const intersection = new IntersectionObserver((entries) => {
                visible = entries[0].isIntersecting;
                start();
            }, { threshold: 0.05 });
            intersection.observe(video);
            const unload = (event) => {
                if (!event.target.contains(video)) return;
                video.pause();
                intersection.disconnect();
                document.removeEventListener('visibilitychange', resume);
                window.removeEventListener('pageshow', resume);
                document.removeEventListener('shopify:section:unload', unload);
            };
            document.addEventListener('shopify:section:unload', unload);
            if (motion.matches) {
                video.autoplay = false;
                video.pause();
            }
        });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(document));
    else setup(document);
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
